<div class="container">
    <h1 jhitranslate="trainings.title">
        <i class="fa fa-code fa-pre" aria-hidden="true"></i> Formations
    </h1>

    <div class="language-selector">
        <span [ngClass]="{'selected': language === 'fr'}" (click)="switchLanguage('fr')">Français</span>
        -
        <span [ngClass]="{'selected': language === 'en'}" (click)="switchLanguage('en')">Anglais</span>
    </div>

    <div class="filters-parent">
        <div class="filters">
            <label class="control-label" for="search">Rechercher</label>
            <input
                class="form-control input-filter"
                id="search"
                type="text"
                [(ngModel)]="search"
                (ngModelChange)="searchTrainings()"
                placeholder="Filtrer par nom ou par référence"
                #searchInput
            />
            <div (click)="activeClicked()" class="active-filter">
                Active :
                <span *ngIf="active"
                    ><i class="fa fa-check-circle" aria-hidden="true"></i
                ></span>
                <span *ngIf="!active"
                    ><i class="fa fa-circle-thin" aria-hidden="true"></i
                ></span>
            </div>
        </div>
    </div>

    <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th>Titre</th>
                    <th>Référence</th>
                    <th>Durée</th>
                    <th>Prix</th>
                    <th>Active</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngFor="
                        let training of trainings
                            | filterByTitle: search
                            | filterByActive: active
                    "
                    uiSref="training-detail"
                    [uiParams]="{ id: training.id }"
                >
                    <td>{{ getTitle(training) }}</td>
                    <td>{{ training.reference }}</td>
                    <td style="min-width: 100px;">{{ training.days }}</td>
                    <td style="min-width: 100px;">
                        {{ training.price / 100 }}
                        {{ convertCurrency(training.priceCurrency) }}
                    </td>
                    <td *ngIf="training.active">
                        <i class="fa fa-check-circle" aria-hidden="true"></i>
                    </td>
                    <td *ngIf="!training.active">
                        <i class="fa fa-circle-thin" aria-hidden="true"></i>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <button class="btn btn-primary btn-round btn-lg" uiSref="training-create">
        +
    </button>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/training/training.component.html